import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import ContentSections from "./components/ContentSections";
import ArticleSection, { FinalCta } from "./components/ArticleSection";
import { SITE_URL, SITE_LOGO } from "@/lib/seo";

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "USFansLink.study",
  alternateName: "USFans Spreadsheet",
  url: SITE_URL,
  inLanguage: ["en", "fr", "es", "pl"],
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "USFansLink.study",
  url: SITE_URL,
  logo: SITE_LOGO,
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-16">
        <Hero />
        <CategorySection />
        <ContentSections />
        <ArticleSection />
        <FinalCta />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
    </div>
  );
}